import React from 'react';
import { withRouter } from 'react-router';

import classnames from 'classnames';
import PropTypes from 'prop-types';

import { sendEvent } from './membershipBannerEvents';

import Icons from '../components/icons';
import { I18n } from '../components/translate';
import Settings from '../configs/Settings';
import { EVENTS_LABELS } from '../modules/app/services/datahub/constants';

const MembershipBannerButton = ({ className, location }) => {
  return (
    <a
      href={`${Settings.app.bw}/membership/list`}
      onClick={() =>
        sendEvent(EVENTS_LABELS.MEMBERSHIP_BANNER.LEARN_MORE, location.pathname)
      }
      target="_blank"
      rel="noreferrer noopener"
      className={classnames(
        'hot-button hot-button--success _text-decoration-none _d-flex _align-items-center',
        className
      )}
    >
      <I18n label="membership_banner.action" />
      <Icons
        prefix="fal"
        iconName="arrow-right"
        className="_ml-1"
        aria-hidden
      />
    </a>
  );
};

MembershipBannerButton.propTypes = {
  className: PropTypes.string,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired
  }).isRequired
};

MembershipBannerButton.defaultProps = {
  className: ''
};

export default withRouter(MembershipBannerButton);
